import { RefreshCw } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import DynamicTextEditorRenderer from "./editor";
import DynamicTextEmailRenderer from "./email";
import { DynamicTextEmailPanelRenderer } from "./email-panel";
import type { DynamicTextBlock, DynamicTextBlockProps } from "./types";

export default registerBlock<DynamicTextBlockProps>({
  type: "dynamic-text",
  name: "editorBlocksLibrary.blocks.dynamicText.title",
  description: "editorBlocksLibrary.blocks.dynamicText.description",
  Icon: RefreshCw,
  category: BlockCategory.ESSENTIALS,
  isTranslated: (locale, block) => {
    const content = (block as DynamicTextBlock).content;

    return (
      !!content &&
      content?.[locale]?.html?.replace(/<[^>]+>/g, "").trim().length > 0
    );
  },
  components: {
    email: {
      component: DynamicTextEmailRenderer,
      editor: {
        component: DynamicTextEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: DynamicTextEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: true,
      },
    },
  },
});

export type {
  DynamicTextBlock,
  DynamicTextBlockProps as DynamicTextEditorRendererProps,
} from "./types";
